import React from "react";

const MapSection = () => (
  <section className="map-section">
    <iframe
      data-sal="slide-up"
      data-sal-duration="1000"
      data-sal-delay="100"
    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3805.670666782034!2d78.571255!3d17.47547!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9c7ebb71fe37%3A0xd08661f7b2665f65!2sLifeline%20Tulasi%20Multispeciality%20Hospitals!5e0!3m2!1sen!2sin!4v1768903795479!5m2!1sen!2sin" 
      
      width="600"
      height="450"
      style={{ border: 0 }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="map_location"
    ></iframe>
  </section>
);

export default MapSection;
